import { balanceChannel } from './balance/channel'
import { publicChannel } from './public/channel'
import { userChannel } from './user/channel'

export const WS_CHANNELS = [
  {
    channel: userChannel,
    getName: (userId) => `user#${userId}`,
  },
  {
    channel: balanceChannel,
    getName: (userId) => `balance#${userId}`,
  },
  {
    channel: publicChannel,
    getName: () => 'public:sync-data',
  },
]
